module.exports = '<svg width="37" height="32" viewBox="0 0 37 32"><path d="M2.286 13.714h9.143a2.284 2.284 0 0 0 2.286-2.286V2.285a2.284 2.284 0 0 0-2.286-2.286H2.286A2.284 2.284 0 0 0 0 2.285v9.143a2.284 2.284 0 0 0 2.286 2.286zM16 18.286H2.286A2.284 2.284 0 0 0 0 20.572v9.143a2.284 2.284 0 0 0 2.286 2.286H16a2.284 2.284 0 0 0 2.286-2.286v-9.143A2.284 2.284 0 0 0 16 18.286zM34.286 4.571h-9.143a2.284 2.284 0 0 0-2.286 2.286v18.286a2.284 2.284 0 0 0 2.286 2.286h9.143a2.284 2.284 0 0 0 2.286-2.286V6.857a2.284 2.284 0 0 0-2.286-2.286z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/dashboard-1.js
// module id = 1096
// module chunks = 14